module.exports = __webpack_public_path__ + "media/en.f2fa2892.mp3";